
import React from 'react';
import { 
  Card, 
  CardHeader, 
  CardTitle, 
  CardDescription, 
  CardContent 
} from '@/components/ui/card';

const TripNotFound: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Card>
        <CardHeader>
          <CardTitle>Trip Not Found</CardTitle>
          <CardDescription>
            The trip you're looking for doesn't exist or you don't have access to it.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p>Please check the URL and try again, or contact the trip organizer.</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default TripNotFound;
